import React, { useReducer, createContext } from "react";
import PropTypes from 'prop-types';
import { findIndex } from 'lodash';

export const WorkExperienceContext = createContext();

function workExpReducer(state, action) {
    const userInfo = state[0];
    const expList = state[1];
    switch (action.type) {
        case 'get': {
            const { data } = action;
            return [
                data[0][0],
                data[1]
            ];
        }

        case 'add': {
            const { item } = action;
            const newList = [
                ...expList,
                item[0]
            ]
            return [
                userInfo,
                newList
            ];
        }

        case 'update': {
            const { item } = action;
            const newList = [...expList];
            const index = findIndex(newList, {id: item.id});
            newList.splice(index, 1, item);
            return [
                userInfo,
                newList
            ];
        }

        case 'update-milestone': {
            const { info } = action;
            return [
                info,
                expList
            ];
        }

        case 'remove': {
            const { item } = action;
            const newList = [...expList];
            const index = findIndex(newList, {id: item.id});
            newList.splice(index, 1);
            return [
                userInfo,
                newList
            ];
        }

        default: {
            throw new Error(`Unhandled action type: ${action.type}`)
        }
    }
}

export const WorkExperienceContextContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(workExpReducer, []);

    const value = {state, dispatch}

    return (
        <WorkExperienceContext.Provider
        value={value}
        >
        {children}
        </WorkExperienceContext.Provider>
    );
}

// PropTypes
WorkExperienceContextContextProvider.propTypes = {
    children: PropTypes.element
}